module.exports = __webpack_public_path__ + "static/media/5. Capas Interiores, Mixta sobre acrílico y papel, 28 x 36 cm, 2017 copy.17e149e5.png";